<template>
  <div class="resources__glossary" id="resources__glossary">
     <h1 v-html="$t('resourcesTranslate.resourcesGlossaryTitle')" class="resources__glossary--title"></h1>
     <div class="resources__glossary--body">
       <ul class="resources__glossary--body--linklist">
         <li v-for="resource in glossary" :key="resource.id" class="resources__glossary--body--linklist--item">
           <a v-html="$t(resource.link_title)" :href="resource.link_url" target="_blank"></a>
         </li>
       </ul>
     </div>
  </div>
</template>

<script>
export default {
  name: 'resources-entry',
  data() {
    return {
      locale: 'fr',
      glossary: [
        {
          link_title: "resourcesTranslate.resourcesGlossaryLinks1",
          link_url: "http://www.cnq.org/"
        },
        {
          link_title: "resourcesTranslate.resourcesGlossaryLinks6",
          link_url: "https://www.rdprm.gouv.qc.ca/fr/Pages/Accueil.htmlhttp://www.lacopropriete.info/"
        },
        {
          link_title: "resourcesTranslate.resourcesGlossaryLinks3",
          link_url: "https://www.rdl.gouv.qc.ca/"
        },
        {
          link_title: "resourcesTranslate.resourcesGlossaryLinks5",
          link_url: "https://www.registrefoncier.gouv.qc.ca/Sirf/"
        },
        {
          link_title: "resourcesTranslate.resourcesGlossaryLinks2",
          link_url: "http://www.lacopropriete.info/"
        }
      ]
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>
